import { render, staticRenderFns } from "./AlarmActionSendSeprobanModal.vue?vue&type=template&id=98045e46"
import script from "./AlarmActionSendSeprobanModal.vue?vue&type=script&lang=js"
export * from "./AlarmActionSendSeprobanModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports